import CalendarService from "./CalendarService"
import {
    dateInRange,
    getSortingDate,
    getStartEndDates,
    sortEvents,
} from "./utils"

export const getters = {
    eventsInRange: state => (start, end) => {
        const events = state.events.filter(event => {
            const eventDate = getSortingDate(event)
            return dateInRange(eventDate, start, end)
        })
        return sortEvents(events)
    },
}

export const mutations = {
    setEvents(state, { events }) {
        events.forEach(event => {
            const idx = state.events.findIndex(e => e.id === event.id)
            if (idx !== -1) {
                state.events[idx] = event
            } else {
                state.events.push(event)
            }
        })
    },

    clearModule(state) {
        state.events = []
    },
}

export function makeActions(service) {
    return {
        async updateEvents({ commit, dispatch }, { startDate, endDate }) {
            try {
                const events = await service.getCalendarEvents({
                    startDate,
                    endDate,
                })
                commit("setEvents", { events })
            } catch (error) {
                if (
                    error instanceof DOMException &&
                    error.name === "AbortError"
                )
                    return
                dispatch(
                    "pushNotification",
                    {
                        title: error.message,
                        type: "error",
                    },
                    { root: true }
                )
            }
        },

        updateMonthEvents({ dispatch, rootGetters }, { month, year }) {
            const timeZone = rootGetters.currentUser?.timeZone
            const { startDate, endDate } = getStartEndDates({
                month,
                year,
                timeZone,
            })
            dispatch("updateEvents", { startDate, endDate })
        },
    }
}

export default {
    namespaced: true,
    state: {
        events: [],
    },
    getters,
    mutations,
    actions: makeActions(new CalendarService()),
}
